module.exports = __webpack_public_path__ + "static/media/MAPOTAFU_MENU-normal.ebcd9d50.png";